module.exports = __webpack_public_path__ + "img/Character_Lumine_Thumb.8aed7bae.png";